import dashboardImg from "../../assets/kpi.png";
import filterImg from "../../assets/lh-filter.png";
import performanceImg from "../../assets/performancelh.png";
import fivepages from "../../assets/5pages.png";
import { useState } from "react";

export function renderDashboard() {
  return <DashboardComponent />;
}

function DashboardComponent() {
    const [zoomVideo, setZoomVideo] = useState(null);
    const [zoomImage, setZoomImage] = useState(null);

    return (
    <div className=" text-slate-900 dark:text-slate-100 font-body antialiased transition-colors duration-300">
        <main className="hide-scrollbar py-10">
          <div className="">
            <div className="flex flex-wrap items-center gap-2 mb-6 text-sm">
              <a className="text-slate-500 dark:text-[#90a9cb] hover:text-primary transition-colors" href="#">Netraa LH</a>
              <span className="text-slate-400 dark:text-slate-600">/</span>
              <a className="text-slate-500 dark:text-[#90a9cb] hover:text-primary transition-colors" href="#">Product Capabilities</a>
              <span className="text-slate-400 dark:text-slate-600">/</span>
              <span className="text-primary font-medium">Dashboard</span>
            </div>

            <header className="mb-10 border-b border-slate-200 dark:border-border-dark pb-8">
              <div className="flex items-center gap-3 mb-4">
                <span className="px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-semibold uppercase tracking-wider border border-primary/20">Operations Guide</span>
              </div>
              <h1 className="text-5xl lg:text-5xl font-extrabold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">Dashboard Operations</h1>
              <p className="text-lg text-slate-600 dark:text-slate-300 font-light">
                Monitor the real-time health and performance of all your configured applications and services. Gain instant insights into system availability and proactive anomaly detection.
              </p>
            </header>

            <section className="mb-16 scroll-mt-24" id="kpi-dashboard">
  <div className="flex items-center gap-4 mb-6">
    <h2 className="text-2xl font-bold text-slate-900 dark:text-white font-display">
      KPI Dashboard
    </h2>
    <div className="h-px bg-slate-200 dark:bg-border-dark flex-1" />
  </div>

  {/* Content + Image (Stacked Layout) */}
  <div className="space-y-8 mb-8">
    
    {/* Text Content */}
    <div>
      <p className="text-slate-600 dark:text-slate-300 mb-4 leading-relaxed">
        The KPI Dashboard serves as the central command center for high-level metrics. 
        It aggregates data points from all active monitors to provide a health score 
        of your synthetic ecosystem.
      </p>

      <h4 className="text-sm font-bold text-slate-900 dark:text-white uppercase tracking-wider mb-3">
        Key Metrics
      </h4>

      <ul className="space-y-2">
        <li className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
          <span className="size-1.5 rounded-full bg-primary" />
          Availability %
        </li>
        <li className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
          <span className="size-1.5 rounded-full bg-primary" />
          Avg Page Response
        </li>
        <li className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
          <span className="size-1.5 rounded-full bg-primary" />
          Downtime Duration
        </li>
        <li className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
          <span className="size-1.5 rounded-full bg-primary" />
          Error Count
        </li>
        <li className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
          <span className="size-1.5 rounded-full bg-primary" />
          Apdex Score
        </li>
      </ul>
    </div>


      <img
        src={dashboardImg}
        alt="Netraa LH KPI Dashboard Overview"
        className="w-auto h-auto object-cover"
        onClick={() => setZoomImage(dashboardImg)}
      />
  </div>

 {/* Filter Controls Section */}
<div className="bg-slate-50 dark:bg-card-dark rounded-xl border 
                border-slate-200 dark:border-border-dark p-6">

  <h3
    className="text-lg font-bold text-slate-900 dark:text-white mb-6 
               flex items-center gap-2"
    id="filters"
  >
    <span className="material-symbols-outlined text-primary">
      filter_alt
    </span>
    Filter Controls
  </h3>

  <div className="space-y-8">

    {/* Text Content */}
    <div>
      <h4 className="font-bold text-slate-800 dark:text-slate-200 mb-2 text-sm">
        Navigation &amp; Filters
      </h4>
      <p className="text-sm text-slate-600 dark:text-slate-400 mb-4 leading-relaxed">
        Use the sidebar filters to drill down by Domain, Location, or Monitor Type.
        Selecting a filter instantly updates all KPI widgets.
      </p>

      <h4 className="font-bold text-slate-800 dark:text-slate-200 mb-2 text-sm">
        Date Range Selection
      </h4>
      <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
        Standard ranges (1h, 24h, 7d) are available alongside a custom date picker
        for retrospective incident analysis.
      </p>
    </div>

    {/* Snippet / Image Below */}

      <img
        src={filterImg}   // <-- replace with your image variable
        alt="Filter & Selection Controls"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(filterImg)}
      />
    </div>
  </div>
</section>

            <section className="mb-16 scroll-mt-24" id="live-execution">
              <div className="flex items-center gap-4 mb-6">
                <h2 className="text-2xl font-bold text-slate-900 dark:text-white font-display"> Live Dashboard</h2>
                <div className="h-px bg-slate-200 dark:bg-border-dark flex-1" />
              </div>
              <p className="text-slate-600 dark:text-slate-300 mb-8 leading-relaxed">
                The Live Dashboard provides real-time visibility into the execution status of your synthetic monitors. It is designed for operations centers (NOC) requiring up-to-the-second status updates.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-4 flex items-center justify-between">
                  <div>
                    <p className="text-xs font-bold text-green-600 dark:text-green-400 uppercase tracking-wider">Success</p>
                    <p className="text-2xl font-bold text-slate-900 dark:text-white">842</p>
                  </div>
                  <span className="material-symbols-outlined text-3xl text-green-500">check_circle</span>
                </div>
                <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4 flex items-center justify-between">
                  <div>
                    <p className="text-xs font-bold text-blue-600 dark:text-blue-400 uppercase tracking-wider">Running</p>
                    <p className="text-2xl font-bold text-slate-900 dark:text-white">12</p>
                  </div>
                  <span className="material-symbols-outlined text-3xl text-blue-500 animate-spin">sync</span>
                </div>
                <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4 flex items-center justify-between">
                  <div>
                    <p className="text-xs font-bold text-red-600 dark:text-red-400 uppercase tracking-wider">Terminated</p>
                    <p className="text-2xl font-bold text-slate-900 dark:text-white">3</p>
                  </div>
                  <span className="material-symbols-outlined text-3xl text-red-500">cancel</span>
                </div>
              </div>

              <div className="bg-white dark:bg-card-dark rounded-xl border border-slate-200 dark:border-border-dark overflow-hidden">
                <div className="p-6 border-b border-slate-200 dark:border-border-dark">
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">Tabular Data Specifications</h3>
                  <p className="text-sm text-slate-500 dark:text-slate-400 mb-4">The live table includes the following sortable columns:</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-2 py-1 bg-slate-100 dark:bg-background-dark border border-slate-200 dark:border-border-dark rounded text-xs font-mono text-slate-600 dark:text-slate-300">Monitor Name</span>
                    <span className="px-2 py-1 bg-slate-100 dark:bg-background-dark border border-slate-200 dark:border-border-dark rounded text-xs font-mono text-slate-600 dark:text-slate-300">Freq</span>
                    <span className="px-2 py-1 bg-slate-100 dark:bg-background-dark border border-slate-200 dark:border-border-dark rounded text-xs font-mono text-slate-600 dark:text-slate-300">Status</span>
                    <span className="px-2 py-1 bg-slate-100 dark:bg-background-dark border border-slate-200 dark:border-border-dark rounded text-xs font-mono text-slate-600 dark:text-slate-300">Platform</span>
                    <span className="px-2 py-1 bg-slate-100 dark:bg-background-dark border border-slate-200 dark:border-border-dark rounded text-xs font-mono text-slate-600 dark:text-slate-300">Time</span>
                    <span className="px-2 py-1 bg-slate-100 dark:bg-background-dark border border-slate-200 dark:border-border-dark rounded text-xs font-mono text-slate-600 dark:text-slate-300">Next Run</span>
                    <span className="px-2 py-1 bg-slate-100 dark:bg-background-dark border border-slate-200 dark:border-border-dark rounded text-xs font-mono text-slate-600 dark:text-slate-300">Domain</span>
                  </div>
                </div>
                <div className="p-6 bg-slate-50 dark:bg-black/20">
                  <div className="flex items-center justify-center">
<video
  className="w-25 h-45 object-cover object-top cursor-zoom-in"
  autoPlay
  loop
  muted
  playsInline
  onClick={() => setZoomVideo("/videos/livedashbrd.webm")}
>
  <source src="/videos/livedashbrd.webm" type="video/webm" />
</video>

</div>
                </div>
              </div>
            </section>

            <section className="mb-16 scroll-mt-24" id="performance-analytics">
  
  {/* Section Header */}
  <div className="flex items-center gap-4 mb-6">
    <h2 className="text-2xl font-bold text-slate-900 dark:text-white font-display">
      Performance Analytics
    </h2>
    <div className="h-px bg-slate-200 dark:bg-border-dark flex-1" />
  </div>

  {/* Content + Image (Stacked) */}
  <div className="space-y-10 mb-10">

    {/* Text Content */}
    <div className="">
      <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-3">
        Monitor Specific Analysis
      </h3>

      <p className="text-slate-600 dark:text-slate-300 text-sm mb-6 leading-relaxed">
        Deep dive into specific monitors using the dropdown selection. 
        This view isolates metrics to help identify regression trends over time.
      </p>

      <h4 className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-3">
        Detailed Metrics
      </h4>

      <ul className="space-y-2 text-sm text-slate-600 dark:text-slate-400 
                     border-l-2 border-primary pl-4 mb-6">
        <li>Connect Time (TCP)</li>
        <li>First Byte Time (TTFB)</li>
        <li>DOM Load Time</li>
        <li>Total Page Load</li>
      </ul>

      <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
        <h4 className="text-primary font-bold text-sm mb-1 flex items-center gap-2">
          <span className="material-symbols-outlined text-sm">
            trending_up
          </span>
          Graph Component
        </h4>
        <p className="text-xs text-slate-600 dark:text-slate-300 leading-relaxed">
          "Daily Page Response Time Trends" visualizes latency spikes 
          correlated with deployment times.
        </p>
      </div>
    </div>

    {/* Graph / Image Below */}

      <img
        src={performanceImg}  // <-- replace with your image variable
        alt="Performance Trend Graph & Analytics"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(performanceImg)}
      />


  </div>

  {/* Bottom Highlight Section (Unchanged Layout) */}
<div className="rounded-xl bg-gradient-to-r 
                from-slate-900 to-slate-800 
                dark:from-card-dark dark:to-background-dark 
                border border-slate-200 dark:border-border-dark 
                p-6 relative overflow-hidden">

  <div className="absolute top-0 right-0 p-24 bg-primary opacity-5 blur-3xl rounded-full 
                  translate-x-1/2 -translate-y-1/2 pointer-events-none" />

  <div className="flex flex-col gap-6 relative z-10">

    {/* Content First */}
    <div>
      <h3 className="text-xl font-bold text-white mb-2">
        Top 5 Slow Pages
      </h3>
      <p className="text-slate-400 text-sm leading-relaxed">
        Automatically identifies the worst-performing URLs in your monitored suite. 
        This table updates dynamically to highlight areas needing immediate optimization.
      </p>
    </div>

    {/* Image Below */}

      <img
        src={fivepages}
        alt="Performance Trend Graph & Analytics"
        className="w-auto h-auto object-cover"
        onClick={() => setZoomImage(fivepages)}
      />

  </div>
</div>
</section>
{zoomVideo && (
  <div
    className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
    onClick={() => setZoomVideo(null)}
  >
    <video
      className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-2xl"
      autoPlay
      loop
      muted
      playsInline
      controls
    >
      <source src={zoomVideo} type="video/mp4" />
    </video>
  </div>
)}
{zoomImage && (
  <div
    className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
    onClick={() => setZoomImage(null)}
  >
    <img
      src={zoomImage}
      alt="Zoomed Preview"
      className="max-w-[90vw] max-h-[90vh] rounded-xl shadow-2xl object-contain"
    />
  </div>
)}
          </div>
        </main>
      </div>
);
}